import React, { Component } from 'react';
import $ from "jquery";
import PersonalContactInformation from './partTimeEmpPages/PersonalContactInformation';
import ProfessionalAcademicCredentials from './partTimeEmpPages/ProfessionalAcademicCredentials';
import EmploymentProfessionalHistory from './partTimeEmpPages/EmploymentProfessionalHistory';
import EngagementTermsWorkScope from './partTimeEmpPages/EngagementTermsWorkScope';
import PaymentRecordsFinancialTransactions from './partTimeEmpPages/PaymentRecordsFinancialTransactions';


class AddPartTimeEmployeeDetailsPopup extends Component {
  constructor(props) {
    super(props);
    this.id = this.props.emp_id;
    this.state = {
      form_type_list : ['Personal & Contact Information','Professional & Academic Credentials','Employment & Professional History','Engagement Terms & Work Scope','Payment Records & Financial Transactions'],
      form_type_view:[],
      form_view_list:[<PersonalContactInformation page_title="Personal & Contact Information" id={this.id}/>,<ProfessionalAcademicCredentials page_title='Professional & Academic Credentials' id={this.id}/>,<EmploymentProfessionalHistory page_title="Employment & Professional History" id={this.id}/>,<EngagementTermsWorkScope page_title='Engagement Terms &amp; Work Scope' id={this.id}/>,<PaymentRecordsFinancialTransactions page_title='Payment Records &amp; Financial Transactions' id={this.id}/>],
      view_form:'',
    };
  }

  componentDidMount(){
    var form_type_view = [];
    var list = this.state.form_type_list;
    for (var i = 0; i < list.length; i++) {
      var for_name = list[i];
      form_type_view.push(
      <option value={for_name}>{for_name}</option>
      );
    }
    this.setState({form_type_view});
    setTimeout(function (){
      $('#form_type').val(list[0]);
      this.selectionsFormType();
    }.bind(this),100);
  }

  selectionsFormType(){
    var form_type = $('#form_type').val();
    var form_type_list = this.state.form_type_list;
    var form_view_list = this.state.form_view_list;
    var view_form = '';
    if(form_type_list.includes(form_type)){
      view_form = form_view_list[form_type_list.indexOf(form_type)];
    }else {
      view_form = '';
    }
    this.setState({view_form});
  }


  render() {
    return (
        <>
        <div className="modal fade" id="myModal" role="dialog">
          <div className="modal-dialog popup_view_width">
            <div className="modal-content">
              <div className="modal-header">
              <h4 className="modal-title" id="page_titlte">Add Employee Details</h4>
                <button type="button" className="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
              </div>
              <div className="modal-body">


              <div className="">
              <div className="col-md-12">
                  <div className="wow fadeInUp" data-wow-delay="0.5s">
                      <form action="" method="post">
                          <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="full_name" placeholder="Full Name" value={this.props.fullname} readOnly="true"/>
                                        <label for="name">Full Name</label>
                                    </div>
                                </div>
                              <div className="col-md-4">
                                  <div className="form-floating">
                                      <select class="form-control form-select" id="form_type" name="form_type" onChange={this.selectionsFormType.bind(this)}>
                                      <option value="">Employee Form Type</option>
                                      {this.state.form_type_view}
                                  </select>
                                  <label for="name">Employee Form Type</label>
                                  </div>
                              </div>

                          </div>
                          <div className="form_popup_scroll">
                            {this.state.view_form}
                          </div>
                      </form>
                  </div>
              </div>
              </div>


              </div>
            </div>
          </div>
        </div>


        </>
    );
  }
}

export default AddPartTimeEmployeeDetailsPopup;
